import { Component } from '@angular/core';

/**
 * Generated class for the PpmapComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ppmap',
  templateUrl: 'ppmap.html'
})
export class PpmapComponent {

  text: string;

  constructor() {
    //TODO falls Map irgendwo sonst gebraucht wird...
    console.log('Hello PpmapComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/ppmap/ppmap.ts